import React, { useState, useEffect } from 'react'
import { Route, Redirect } from 'react-router-dom'
import User from '../../services/User'

export default ({ component: Component, ...rest }) => {
    const [isSignedIn, setIsSignedIn] = useState()

    useEffect(() => {
        User.isSignedIn(setIsSignedIn)
    }, [])

    return (
        <Route
            {...rest}
            render={props => {
                if (isSignedIn === undefined) {
                    return false
                } else if (isSignedIn) {
                    return <Component {...props} />
                } else {
                    return <Redirect to={{ pathname: '/login', state: { from: props.location } }} />
                }
            }
            }
        />
    )
}